import { Reward } from '@/models/reward';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgCelebratePoints',
})
export default class CmgCelebratePoints extends Vue {
  watchers: (() => any)[] = [];

  get isVisible(): boolean {
    return this.$appStore.state.ui.pointsCelebrationVisible;
  }

  get pepperBadgeUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get pepperShoutUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  get points(): number {
    return this.$services.reward.getPointsBalance();
  }

  get pointsNeeded(): number {
    if (this.favoriteReward && this.favoriteReward.points > this.points) {
      return this.favoriteReward.points - this.points;
    }

    return 0;
  }

  get message(): string {
    if (this.favoriteReward) {
      if (this.hasUnlockedReward) {
        return '';
      } else {
        return `${this.pointsNeeded} points to go for ${this.favoriteReward.title}`;
      }
    } else if (this.numRedeemableRewards > 0) {
      return `${this.numRedeemableRewards} item${this.numRedeemableRewards > 1 ? 's' : ''} redeemable now in the store`;
    } else {
      return 'Pick a reward and track your progress';
    }
  }

  get numRedeemableRewards(): number {
    return this.$services.reward.getNumRedeemableRewards();
  }
  
  get hasFavoriteReward(): boolean {
    return !!this.favoriteReward; 
  }

  get favoriteReward(): Reward | undefined {
    return this.$services.reward.getFavoriteReward();
  }

  get hasUnlockedReward(): boolean {
    return this.$services.reward.getProgressPercentage() >= 100;
  }
  
  mounted() {
    document.addEventListener('click', this.close.bind(this));
    document.addEventListener('touchstart', this.close.bind(this));
    setTimeout(this.animate, 500);
  }
  
  destroyed() {
    document.removeEventListener('click', this.close.bind(this));
    document.removeEventListener('touchstart', this.close.bind(this));
  }
  
  close(): void {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationLaterClick,
      label: AnalyticsEventLabel.RewardsNotificationLaterClick,
    });

    this.$services.ui.setPointsCelebrationVisibility(false);
  }
  
  onClickClaim(): void {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationClaimClick,
      label: AnalyticsEventLabel.RewardsNotificationClaimClick,
    });
    
    if (this.favoriteReward) {
      this.$services.ui.setModalVisibility('rewardDetail', true, { reward: this.favoriteReward });
    }

    this.close();
  }

  animate(): void {
    const container = this.$refs.celebratePointsContainer as HTMLElement;
    const overlay = this.$refs.overlay as HTMLElement;
    const progressBarContainer = this.$refs.progressBarContainer as HTMLElement;
    const unlockedContainer = this.$refs.unlockedContainer as HTMLElement;

    container.classList.remove('hidden');
    container.childNodes.forEach(node => (node as HTMLElement).classList.remove('hidden'));
    overlay.classList.add('hidden');
    
    // animate image swap
    const img = (document.getElementById('celebratePepperBadge') as HTMLImageElement);
    if (img) {
      setTimeout(() => {
        img.src = this.pepperShoutUrl;
      }, 500);
    }
    
    if (this.hasFavoriteReward) {
      const progressBar = (document.getElementById('progress-bar') as HTMLElement);
      const percentage = this.$services.reward.getProgressPercentage();
      
      setTimeout(() => {
        progressBar.style.width = `${percentage}%`;
      }, 1000);
      
      if (this.hasUnlockedReward) {
        setTimeout(() => {
          progressBarContainer.remove();
          document.getElementsByClassName('text animate')[0].classList.remove('animate');
          unlockedContainer.classList.remove('hidden-delayed');
          container.classList.add('extra-tall');
        }, 2500);
      } else {
        setTimeout(() => {
            container.classList.add('leave');
          }, 4500);
          
        setTimeout(this.close, 5000);
      }
    } else {
      setTimeout(() => {
        container.classList.add('leave');
      }, 3500);
      
      setTimeout(this.close, 4000);
    }
  }
}
  